import { useTranslation } from "react-i18next"

export const BetaBadge = ({ className = "" }) => {
    const { t } = useTranslation()
    return (
        <span
            title={t("common.beta_badge_tooltip")}
            className={
                "inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-800 " +
                className
            }
        >
            {t("common.beta_badge")}
        </span>
    )
}
